export default {
  FontFamily: 'TimesNewRoman',
  FontFamilyText: 'Times New Roman',
  FontSize: 13,
  FontStyleLower: 3, // 1 là upper, 2 là lower, 3 là normal
  PrintPlaceOnReport: false,
  SignPlace: '',
  PrintSystemDate: 2,
  CompanyProvinceTitle: 'Thành phố',
  CompanyDistrictTitle: 'Quận',
  CompanyCommuneTitle: 'Phường',
  IsShowFullAmountOnCAPayment: true,
  IsShowFullAmountOnCAReceipt: true,
};
